import {
  normalizeSupplierInstallationEmissionReportCnCode,
  SUPPLIER_INSTALLATION_EMISSION_REPORT_EXCLUDED_CN_CODE,
} from '@artem-cbam-operator/common-server/supplier-installation-emission-report'

export {
  normalizeSupplierInstallationEmissionReportCnCode,
  SUPPLIER_INSTALLATION_EMISSION_REPORT_EXCLUDED_CN_CODE,
}

const cnCode8DigitsPattern = /^\d{8}$/

export function buildSupplierInstallationEmissionReportValidCnCodeSet(
  goods: ReadonlyArray<{ goodsCode8Digits: string }> | undefined
): ReadonlySet<string> {
  if (!goods) {
    return new Set()
  }

  return new Set(
    goods
      .map((entry) => entry.goodsCode8Digits)
      .filter(
        (code) =>
          code !== SUPPLIER_INSTALLATION_EMISSION_REPORT_EXCLUDED_CN_CODE
      )
  )
}

export function isSupplierInstallationEmissionReportCnCodeValid(
  cnCode: string,
  validCnCodes: ReadonlySet<string>
): boolean {
  const normalized = normalizeSupplierInstallationEmissionReportCnCode(cnCode)
  if (!cnCode8DigitsPattern.test(normalized)) {
    return false
  }
  if (normalized === SUPPLIER_INSTALLATION_EMISSION_REPORT_EXCLUDED_CN_CODE) {
    return false
  }
  return validCnCodes.has(normalized)
}
